import {
  purple,
  spaceCadet,
  ultraMarine,
} from '@cogneed/react-utils';
import { Box, styled } from '@mui/material';
import { orange } from '@mui/material/colors';

const StyledBox = styled(Box)({
  padding: '6px 8px',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: spaceCadet[100],

  '& .step-number': {
    position: 'relative',
    width: 20,
    height: 20,
    borderRadius: '50%',
    marginRight: 4,
    color: 'white',

    '&::before': {
      position: 'absolute',
      top: 0,
      left: '50%',
      transform: 'translate(-50%, 0px)',
      content: 'attr(data-step-number)',
      fontSize: 14,
      lineHeight: '20px',
    },

  },
  '& [data-step-number]': { fontWeight: 700 },
  '& [data-step-number="1"]': { backgroundColor: purple[300], color: purple[500] },
  '& [data-step-number="2"]': { backgroundColor: orange[100], color: orange[600] },
  '& [data-step-number="3"]': { backgroundColor: ultraMarine[300], color: ultraMarine[500] },
});

export default StyledBox;
